import { hexToRgb } from "@material-ui/core";

export const boxShadow =
  "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)";

export const fontFamily = {
  Axiforma: "Axiforma, serif, sans-serf !important"
};

export function hexToRgbA(hex: string, alpha = 1) {
  const rgb = hexToRgb(hex);
  return rgb.replace(")", "," + alpha + ")");
}

export const color = {
  primary: {
    main: "#F7815C",
    light: "#FEEFEB",
    dark: "#AE593E"
  },
  purple: {
    light: "#341561",
    dark: "#1e073f",
    400: "#43335b",
    500: "#51405e"
  },
  orange: "#f7815c",
  white: "#FFFFFF",
  navy: {
    100: "#4b5462"
  }
};
